export function isEnterKey(event: React.KeyboardEvent) {
  return event.key === 'Enter';
}
